import React from 'react';
import emailjs from 'emailjs-com'

 export const sendEmail = (e, dataParams, setMessageToDisplay, setSendingMessageModalVisibility) => {
        e.preventDefault();

        // emailjs.send('service_06ehl19', 'template_01', dataParams, 'user_249SQT2MKsCafyppo4U3a' )
        emailjs.send('service_00u1phl', 'template_nl4gitk', dataParams, 'user_FUf9rKvkCViCt53bd2jRT' )
            .then(function(response) {
                console.log('SUCCESS!', response.status, response.text);
                setMessageToDisplay("SUKCES!!!\nPomyślnie wysłałeś(aś) zamówienie.\nOtrzymasz maila z podsumowaniem.\nJeśli nie otrzymałeś(aś) maila sprawdź w spamie.")
                // window.location.reload()
                setSendingMessageModalVisibility(true)
            }, function(error) {
                console.log('FAILED...', error.text);
                setMessageToDisplay("NIESTETY...\nwystąpił błąd i zamówienie nie zostało wysłane.\nSkontaktuj się z nami telefonicznie lub mailowo w celu wyjaśnienia sytuacji.")
                setSendingMessageModalVisibility(true)
            });
    }